document.addEventListener('DOMContentLoaded', () => {
  initAppRouter();
  initHeader();
  initReveal();
  initNativeContactAnchors();
  const wizard = document.querySelector('[data-candidate-wizard]');
  if (wizard) initCandidateWizard(wizard);
});

function routeInfo(){
  const raw=(location.hash||'').replace(/^#/,'');
  if(!raw || raw==='selector') return {view:'home',anchor:raw==='selector'?'selector':''};
  const parts=raw.split('/');
  const valid=['home','empresas','candidatos','registro-candidato','contacto','legal','iniciar-busqueda','iniciar-servicio'];
  return {view:valid.includes(parts[0])?parts[0]:'home',anchor:parts[1]||''};
}

function initAppRouter(){
  const app=document.querySelector('[data-subsel-app]');
  if(!app) return;
  const views=[...app.querySelectorAll('[data-subsel-view]')];
  const titles={home:'Subsel | Selección y oportunidades laborales',empresas:'Empresas | Subsel',candidatos:'Candidatos | Subsel','registro-candidato':'Crear perfil | Subsel',contacto:'Contacto | Subsel',legal:'Legal y privacidad | Subsel','iniciar-busqueda':'Iniciar búsqueda | Subsel','iniciar-servicio':'Iniciar servicio | Subsel'};
  const apply=()=>{
    const {view,anchor}=routeInfo();
    views.forEach(v=>v.hidden=v.dataset.subselView!==view);
    document.body.dataset.subselRoute=view;
    document.body.classList.toggle('subsel-route-home',view==='home');
    document.title=titles[view]||'Subsel';
    requestAnimationFrame(()=>{
      if(anchor){
        const target=app.querySelector(`[data-subsel-view="${CSS.escape(view)}"] [data-anchor="${CSS.escape(anchor)}"]`) || document.getElementById(anchor);
        if(target) target.scrollIntoView({behavior:'smooth',block:'start'}); else window.scrollTo({top:0,behavior:'smooth'});
      }else if(location.hash==='#selector'){
        document.getElementById('selector')?.scrollIntoView({behavior:'smooth'});
      }else window.scrollTo({top:0,behavior:'auto'});
      initReveal();
    });
  };
  window.addEventListener('hashchange',apply);
  document.addEventListener('click',e=>{
    const link=e.target.closest('a[href^="#"]');
    if(!link) return;
    const href=link.getAttribute('href');
    if(href==='#'||!href) return;
    if(link.dataset.profileLink) localStorage.setItem('subsel_last_profile',link.dataset.profileLink);
    document.body.classList.add('is-transitioning');
    setTimeout(()=>{document.body.classList.remove('is-transitioning');},380);
  });
  apply();
}

function initHeader(){
  const header=document.querySelector('.subsel-header');
  if(header && window.matchMedia('(min-width:901px)').matches){
    document.addEventListener('mousemove',e=>{
      const onHome=document.body.dataset.subselRoute==='home';
      if(!onHome){header.classList.add('is-revealed');return;}
      if(e.clientY<86) header.classList.add('is-revealed');
      else if(window.scrollY<window.innerHeight*.72 && e.clientY>155) header.classList.remove('is-revealed');
    });
    window.addEventListener('scroll',()=>{
      const onHome=document.body.dataset.subselRoute==='home';
      header.classList.toggle('is-revealed',!onHome || window.scrollY>window.innerHeight*.72);
    },{passive:true});
  }
  const toggle=document.querySelector('[data-mobile-toggle]');
  const panel=document.querySelector('[data-mobile-panel]');
  if(toggle&&panel) toggle.addEventListener('click',()=>{const open=panel.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});
}

function initReveal(){
  const els=[...document.querySelectorAll('.reveal:not(.is-visible)')].filter(el=>!el.closest('[hidden]'));
  if(window.SUBSEL_REVEAL===false || window.matchMedia('(prefers-reduced-motion: reduce)').matches){els.forEach(el=>el.classList.add('is-visible'));return;}
  if(!('IntersectionObserver'in window)){els.forEach(el=>el.classList.add('is-visible'));return;}
  const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');io.unobserve(entry.target);}}),{threshold:.12,rootMargin:'0px 0px -40px'});
  els.forEach(el=>io.observe(el));
}

function initNativeContactAnchors(){
  document.querySelectorAll('.subsel-contact-form').forEach(form=>{
    const route=form.closest('[data-subsel-view]')?.dataset.subselView || 'contacto';
    if(form.action) form.action=form.action.split('#')[0]+'#'+route;
  });
}

function initCandidateWizard(wizard){
  const steps=[...wizard.querySelectorAll('[data-wizard-step]')];
  if(!steps.length) return;
  const bar=wizard.querySelector('[data-progress-bar]');
  const label=wizard.querySelector('[data-progress-label]');
  const form=wizard.querySelector('form');
  const storageKey='subsel_candidate_draft_v3';
  const webhook=(wizard.dataset.webhook||'').trim();
  let current=0, partialTimer;

  if(form && !webhook && form.action) form.action=form.action.split('#')[0]+'#registro-candidato';

  const serialize=()=>{const data={};if(!form)return data;new FormData(form).forEach((value,key)=>{if(value instanceof File)return;if(data[key])data[key]=Array.isArray(data[key])?[...data[key],value]:[data[key],value];else data[key]=value;});data._saved_step=current+1;return data;};
  const saveDraft=()=>{try{localStorage.setItem(storageKey,JSON.stringify(serialize()));}catch(e){} schedulePartial();};
  const restore=()=>{try{const data=JSON.parse(localStorage.getItem(storageKey)||'{}');if(Number(data._saved_step)>=1&&Number(data._saved_step)<=steps.length)current=Number(data._saved_step)-1;Object.entries(data).forEach(([key,value])=>{if(key==='_saved_step')return;const nodes=form.querySelectorAll(`[name="${CSS.escape(key)}"]`);nodes.forEach(n=>{const vals=Array.isArray(value)?value:[value];if(n.type==='checkbox'||n.type==='radio')n.checked=vals.includes(n.value);else if(typeof value==='string')n.value=value;});});}catch(e){}};
  const update=()=>{steps.forEach((s,i)=>s.classList.toggle('is-active',i===current));const pct=((current+1)/steps.length)*100;if(bar)bar.style.width=pct+'%';if(label)label.textContent=`Paso ${current+1} de ${steps.length}`;if(current>0)window.scrollTo({top:Math.max(0,wizard.offsetTop-92),behavior:'smooth'});};
  const validateStep=()=>{const currentStep=steps[current];for(const field of [...currentStep.querySelectorAll('[required]')]){if(!field.checkValidity()){field.reportValidity();field.focus();return false;}}return true;};
  const schedulePartial=()=>{if(!webhook||!form)return;clearTimeout(partialTimer);partialTimer=setTimeout(sendPartial,2200);};
  const sendPartial=async()=>{const data=serialize();const email=data['contact[email]']||'';const phone=data['contact[Teléfono]']||'';if(!email&&!phone)return;data._event='candidate_draft';try{await fetch(webhook,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data),keepalive:true});}catch(e){}};

  restore();update();
  form?.addEventListener('input',saveDraft);form?.addEventListener('change',saveDraft);
  wizard.querySelectorAll('[data-next]').forEach(btn=>btn.addEventListener('click',()=>{if(!validateStep())return;saveDraft();if(current<steps.length-1){current++;update();}}));
  wizard.querySelectorAll('[data-prev]').forEach(btn=>btn.addEventListener('click',()=>{if(current>0){current--;saveDraft();update();}}));

  if(webhook&&form){
    form.addEventListener('submit',async e=>{e.preventDefault();if(!validateStep())return;const submit=form.querySelector('[type="submit"]');const original=submit?.textContent||'';if(submit){submit.disabled=true;submit.textContent='Enviando…';}const fd=new FormData(form);fd.set('_event','candidate_submit');try{const res=await fetch(webhook,{method:'POST',body:fd});if(!res.ok)throw new Error('HTTP '+res.status);localStorage.removeItem(storageKey);form.style.display='none';wizard.querySelector('[data-wizard-success]')?.classList.add('is-visible');window.scrollTo({top:Math.max(0,wizard.offsetTop-90),behavior:'smooth'});}catch(err){alert('No pudimos enviar el formulario. Intenta nuevamente o contáctanos directamente.');if(submit){submit.disabled=false;submit.textContent=original||'Crear mi perfil Subsel';}}});
  }
}
